<app-header
  [showBackButton]="true"
  [headerData]="headerDataValues"
  [defaultBackUrl]="defaultBackUrl"
  class="full"
></app-header>
<app-offline-mode></app-offline-mode>
<ion-content>
  <ng-container *ngIf="!loading && request">
    <div class="section">
      <div class="freight-data">
        <div class="text-block">
          <div class="card-title">{{ request.freightName }}</div>
          <div *ngFor="let item of request.freightAttributes">
            <span *ngIf="item.name !== 'ГОСТ'">
              <span class="freight-attributes"> {{ item.name }}: </span>
              <strong>{{ item.value }} {{ item.unit }}</strong>
            </span>
          </div>
          @if (request.cropYear | cropYear; as year) {
            <div>
              <span class="freight-attributes">Год урожая:</span>
              <strong>{{ year }}</strong>
            </div>
          }
        </div>
        <div class="icon-block">
          <div class="freight-icon">
            <img
              alt=""
              [width]="50"
              [height]="50"
              [src]="imageService.generateOrderImgPath(request.freightName)"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="loading-block">
      <div class="start-loading">
        <div class="title">Начало погрузки:</div>
        <div class="value">
          {{ request.shipmentDates[0] | date : 'dd.MM.yyyy' }}
        </div>
      </div>
      <div class="split-section">
        <div class="weight-block">
          <div class="total-weight">
            <div class="title">Вес товара:</div>
            <div class="value">
              <span style="color: #00bfa8; font-weight: 700">
                {{ request.requestedWeightInTons }}
              </span>
              тонн
            </div>
          </div>
          <div class="total-weight">
            <div class="title">Скорость погрузки:</div>
            <div class="value">
              <span style="font-weight: 700">
                {{ request.loading.maxTonPerDay | numberSeparator }}
              </span>
              т / сутки
            </div>
          </div>
          <div class="total-weight">
            <div class="title">Вознаграждение экспедитора:</div>
            <div class="value">
              <span style="color: #00bfa8; font-weight: 700">
                {{ calculateTotalFee() | numberSeparator }} ₽
              </span>
            </div>
          </div>
        </div>
        <div class="section-divider"></div>
        <div class="loading-data">
          <div class="title">Кол-во дней погрузки:</div>
          <span class="day-count">
            <span class="count"> {{ request.shipmentDates.length }} </span>
            {{ request.shipmentDates.length | pluralizeDays }}
          </span>

          <div
            class="loading-dates"
            *ngFor="
              let monthYear of request.shipmentDates | groupDates | keyvalue
            "
          >
            <div class="month">{{ monthYear.key }}:</div>
            <div class="days">{{ monthYear.value }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="section">
      <!--  #TODO: Привязать к бекенду DT1861-417    -->
      <div div class="document-flags">
        <img
          ngSrc="assets/icon/warning-icon.svg"
          alt=""
          width="20"
          height="20"
        />
        <span class="text"> Требуется карантинный сертификат </span>
      </div>
      <!--      <div class="document-flags" *ngIf="request.sampling">-->
      <!--        <img src="../../../assets/icon/checked-icon-round.svg" alt />-->
      <!--        <div class="text">Проба есть</div>-->
      <!--      </div>-->
      <!--      <div class="document-flags" *ngIf="request.quarantineCertificate">-->
      <!--        <img src="../../../assets/icon/checked-icon-round.svg" alt/>-->
      <!--        <div class="text">Карантинный сертификат есть</div>-->
      <!--      </div>-->

      <!--      <div class="document-flags" *ngIf="!request.sampling">-->
      <!--        <img src="../../../assets/icon/warning-icon.svg" alt/>-->
      <!--        <div class="text">Необходима проба</div>-->
      <!--      </div>-->
      <!--      <div class="document-flags" *ngIf="!request.quarantineCertificate">-->
      <!--        <img src="../../../assets/icon/warning-icon.svg" alt/>-->
      <!--        <div class="text">Необходим карантинный сертификат</div>-->
      <!--      </div>-->
    </div>

    <div class="section">
      <div class="title">Пункт погрузки:</div>
      <div
        class="address"
        style="font-weight: 600; text-decoration: none !important"
      >
        {{ request.loading.title }}
      </div>
      <div class="address">{{ request.loading.address }}</div>
      <a
        [href]="'http://maps.apple.com/?q=' + request.loading.address"
        class="location-section"
      >
        <ion-button
          class="light square ion-activatable ion-selectable ion-focusable"
          mode="md"
        >
          <ion-icon
            class="location"
            src="../../../assets/icon/location-icon.svg"
          ></ion-icon>
        </ion-button>
      </a>
    </div>

    <div class="section">
      <div class="title">Организация продавца:</div>
      <div class="value">
        {{ request.seller.orgName }}
        <span style="margin-left: 4px" *ngIf="request.seller.inn"
          >ИНН {{ request.seller.inn }}</span
        >
      </div>
      <div class="title">Контакты продавца товара:</div>
      <a class="phone-number" href="tel:{{ request.seller.phone }}">
        {{ request.seller.phone | phoneNumber }}
      </a>
    </div>
    <div class="accept-order-block">
      <ion-button (click)="acceptOrder()" class="primary large" mode="md">
        Принять заявку
      </ion-button>
    </div>
  </ng-container>
</ion-content>
